<template>
  <div>
    <div>
      <template>
        <div class="text-xs-center">
          <v-dialog content-class="dialog" persistent v-model="dialog" width="500">
            <v-card>
              <v-card-text>
                <v-text-field
                  id="text_field"
                  type="number"
                  v-model="dimension"
                  :label="label"
                  tabindex="-1"
                  step="10"
                  min="0"
                  required
                  @keyup.enter="saveChanges"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="saveChanges">{{$t('pallet_dimensions.save')}}</v-btn>
                <v-btn color="primary" flat @click="dialog = false">{{$t('pallet_dimensions.close')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Pallet from "@/models/Pallet.js";
export default {
  data() {
    return {
      dimension: 0,
      field: "width",
      label: "",
      pallet: {},
      dialog: false
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        document.addEventListener("keyup", e => {
          if (e.key === "Escape") {
            this.dialog = false;
          }
        });
      }
    }
  },
  methods: {
    async saveChanges() {
      this.pallet[this.field] = this.dimension;
      await this.pallet.save();
      this.$emit('updated');
      this.dialog = false;
    },

    async openDialog(pallet, dimension, divider) {
      this.field = dimension;
      this.dimension = Math.round(pallet[dimension] * divider);
      this.pallet = await Pallet.loadPallet(pallet.id);
      if (dimension == "width") {
        this.label = this.$t("pallet_dimensions.width");
      } else {
        this.label = this.$t("pallet_dimensions.length");
      }
      this.dialog = true;
      const textField = document.getElementById("text_field");
      setTimeout(() => {
        textField.focus();
        textField.select();
      }, 50);
    }
  }
};
</script>

<style>
.dialog{
  position: absolute !important;
  bottom: 20px !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 auto !important;
}
</style>